import React, {useEffect} from 'react';
import {useParams, useNavigate} from "react-router-dom";
import {auth} from '../../../store/auth.store';
import paths from "../../../paths";
import {Storage} from "../../../services/localstorege.service";
import {ApiService} from 'lib/http.service';
import {env} from '../../../constants/global.vars';
import _ from "lodash";
import {gtmSelectItem, gtmViewItemList} from "../../../services/misc.functions";
import iconRight from "../../../assets/feather/arrow-right.svg";

const VRGamePlayer = ({slug, isArchive = false}: { slug: string; isArchive?: boolean }) => {
    const accountId = auth.member.id;
    const userToken = auth.token;
    const queryParams = new URLSearchParams({
        slug: slug,
        userToken: userToken || '',
        accountId: String(accountId || ''),
        isArchive: String(isArchive),
        isTest: window.location.origin.includes('test') || window.location.origin.includes('localhost') ? "true" : "false",
    });

    const widgetUrl = `${window.location.origin}/vr-game-widget/vr-game-widget.html?${queryParams.toString()}`;

    return (
        <div className="page-widget vr-game-page" style={{minHeight: '80vh', height: '100%'}}>
            <iframe
                title='Game Loader'
                style={{width: '100%', height: '100%', border: 'none', minHeight: '80vh'}}
                allow="fullscreen; autoplay"
                src={widgetUrl}
            />
        </div>
    );
};

export default function VRGames() {
    const params = useParams();
    const activeSlug = params.subpage;
    const navigate = useNavigate();
    const [gamesList, setGamesList] = React.useState<any[]>([]);
    const [categories, setCategories] = React.useState<any[]>([]);
    const [selectedCategory, setSelectedCategory] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const getGames = async () => {
            const res: any = await new ApiService().start("post", env.accounting_api + "/games/api/list-game/", {
                vendor: 6,
                group_by_category: true,
            }, false);
            if (res && res.status) {
                setGamesList(res.data);
                setCategories(res.data.map((c: any) => c.category));
                gtmViewItemList(res.data, "Oyun");
            }
            setLoading(false);
        };
        getGames();
    }, []);

    useEffect(() => {
        const activeItem = document.querySelector('.category-item.active');
        activeItem?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }, [selectedCategory]);

    const handleSelectCategory = (category: any) => {
        if (category) {
            setSelectedCategory(category);
        } else {
            setSelectedCategory(null);
        }
    }

    if (activeSlug?.includes('gecmis-oyunlar')) {
        return <VRGamePlayer slug="virtual-races" isArchive={true}/>;
    }

    if (activeSlug) {
        return <VRGamePlayer slug={activeSlug} isArchive={false}/>;
    }

    return (
        <div className="page-widget">
            <svg style={{display: "none"}}>
                <defs>
                    <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                </defs>
            </svg>
            <div className={"tab-scroll"}>
                {/* Tab Header */}
                <ul className="nav nav-tabs">
                    <li
                        key={`tabs`}
                        className={`nav-item active`}
                    >
                        <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                        <a className="nav-link" id={`011`}>
                            Sanal Oyunlar
                        </a>
                        <svg className="right" viewBox="0 0 80 60" preserveAspectRatio="none">
                            <use xlinkHref="#tabshape"></use>
                        </svg>
                    </li>
                </ul>
            </div>

            {loading ? (
                <div className="text-white px-4">Oyunlar yükleniyor...</div>
            ) : (
                <div>
                    <div className={"category-list"}>
                        <div className={`category-item ${!selectedCategory && "active"}`}
                             onClick={() => setSelectedCategory(null)}>
                            <span>Tümü</span>
                        </div>
                        {categories.map((category: any, key: number) => {
                            return (
                                <div key={`category-list-${key}`}
                                     className={`category-item ${selectedCategory?.id === category.id && "active"}`}
                                     tabIndex={key}
                                     onClick={() => handleSelectCategory(category)}>
                                    <span>{category.name}</span>
                                </div>
                            )
                        })}
                    </div>

                    {gamesList.map((game: any, key: number) => {
                        const category = game.category;
                        const categoryGames = game.games

                        if (selectedCategory && selectedCategory.id !== category.id) {
                            return null
                        }

                        return (
                            <div key={`games-list-${key}`} className="col-12 mb-4">
                                <h2 className={"ms-3 fs-5"}>{category.name}</h2>
                                <div className="row m-2">
                                    {
                                        categoryGames.map((game: any, key: number) => {
                                            return (
                                                <div key={`games-list-${key}`}
                                                     className="col-6 col-lg-3 mb-4">
                                                    <div className="game-widget">
                                                        <img
                                                            className="games pointer"
                                                            src={`${env.cdn_host}/media/${game.image}`}
                                                            alt={game.name}
                                                            onClick={() => {
                                                                if (game.is_active) {
                                                                    navigate(`${paths.vrgames.url}/${game.code}`);
                                                                    gtmSelectItem([game], "Oyunlar");
                                                                }
                                                            }}
                                                        />
                                                        <div className="playable body mt-2">
                                                        <span
                                                            className="label text-decoration-none text-black pointer"
                                                            onClick={() => {
                                                                if (game.is_active) {
                                                                    navigate(`${paths.vrgames.url}/${game.code}`);
                                                                    gtmSelectItem([game], "Oyunlar");
                                                                }
                                                            }}>
                                                            Hemen Oyna
                                                        </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    );
}
